import React from "react"
import {
  withStyles,
  WithStyles,
  createStyles,
  Typography,
  Theme,
} from "@material-ui/core"

import Heart from "./Heart"

const styles = ({
  breakpoints: { up },
  palette: {
    text: { primary },
  },
}: Theme) => {
  return createStyles({
    root: {
      lineHeight: "2.5rem",
      textAlign: "center",
    },
    icon: {
      width: "1.6875rem",
      fill: primary,
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const Copyright = ({ classes }: Props) => {
  const year: number = new Date().getFullYear()
  return <Typography className={classes.root}>© {year} Outa.app</Typography>
}

export default withStyles(styles)(Copyright)
